import { render, staticRenderFns } from "./TipoProdutoForm.vue?vue&type=template&id=7596fc69"
import script from "./TipoProdutoForm.vue?vue&type=script&lang=js"
export * from "./TipoProdutoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports